/** Navigation symbols always accompany visible text labels. */
export function NavIcon({ name, size = 20 }: { name: string; size?: number }) {
  const paths: Record<string, string> = {
    ozet: "M3 3h7v7H3z M14 3h7v7h-7z M3 14h7v7H3z M14 14h7v7h-7z",
    kpi: "M4 20V4 M4 20h17 M8 16v-4 M13 16V8 M18 16V4",
    stok: "M3 7l9-4 9 4v10l-9 4-9-4z M3 7l9 4 9-4 M12 11v10 M7 5l9 4",
    yorumlar: "M5 3h14a2 2 0 012 2v11a2 2 0 01-2 2H9l-6 4V5a2 2 0 012-2z M7 8h10 M7 12h7",
    denetim: "M9 3h6v4H9z M9 5H5v16h14V5h-4 M8 13l3 3 5-6",
    ayarlar: "M4 6h16 M4 12h16 M4 18h16 M8 3v6 M16 9v6 M10 15v6",
    kurulum: "M9 8V3 M15 8V3 M6 8h12v4a6 6 0 01-12 0z M12 18v4",
    kullanicilar: "M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2 M9 11a4 4 0 100-8 4 4 0 000 8 M17 4a4 4 0 010 7 M22 21v-2a4 4 0 00-3-4",
    admin: "M12 3l9 4v5c0 5-9 9-9 9s-9-4-9-9V7z M8 12l3 3 5-6",
    logout: "M10 4H4v16h6 M8 12h13 M17 8l4 4-4 4",
    more: "M4 6h16 M4 12h16 M4 18h16",
  };
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.65" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="shrink-0"><path d={paths[name] ?? paths.ozet} /></svg>;
}
